<template>
    <div class="tab-list">
        <ul class="nav nav-tabs">
            <li
                :class="{
                    'nav-item': true,
                    'has-errors': errorTabs?.includes(tabKey)
                }"
                v-for="(tabName, tabKey) in tabMap"
                :key="tabKey"
            >
                <a
                    :class="{
                        'nav-link': true,
                        active: activeKey === tabKey,
                    }"
                    href="javascript:void(0)"
                    @click="handleTabChange(tabKey)"
                >
                    {{ tabName }}
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <div v-for="tab in activatedTabs" :key="tab">
                <div v-show="activeKey === tab">
                    <slot :name="tab" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch } from "vue";

export default {
    name: "TabList",
    emits: ["tabChanged"],
    props: {
        keepTabsAlive: {
            type: Boolean,
            default: false
        },
        selectedKey: String,
        tabMap: Object,
        errorTabs: Array
    },
    setup(props, { emit }) {
        const activeKey = ref(props.selectedKey);
        const activatedTabs = ref([props.selectedKey]);

        const handleTabChange = (tab) => {
            setTab(tab);
            emit("tabChanged", tab);
        };

        watch(
            () => props.selectedKey,
            newValue => {
                setTab(newValue);
            }
        );

        const setTab = tab => {
            if (props.keepTabsAlive) {
                if (activatedTabs.value.indexOf(tab) === -1) {
                    activatedTabs.value.push(tab);
                }
            } else {
                activatedTabs.value = [tab];
            }

            activeKey.value = tab;
        }

        return {
            activeKey,
            activatedTabs,
            handleTabChange,
        };
    },
};
</script>

<style scoped lang="scss">
.tab-list {
    li.has-errors a {
        color: red;
        border-top-color: red;
        border-left-color: red;
        border-right-color: red;
    }
}
</style>